import React, { Component } from 'react'
import { connect } from 'redaction'
import actions from 'redux/actions'
import { object, snowplow, constants, compose } from 'common/helpers'

import Button from 'components/buttons/Button/Button'

import messages from './messages'
import s from './ReviewButton.scss'


class ReviewButton extends Component {

  openModal = () => {
    const { data, isLoggedIn, urlToProduct, productTypeGroup, onEditReviewClick } = this.props
    const { reviewsData: { userReview }, id, img, name, brand, category } = data
    const reviewId = userReview ? userReview.id : null

    if (typeof onEditReviewClick === 'function') {
      onEditReviewClick()
      return
    }

    if (!userReview) {
      snowplow.track(constants.snowplowEvents.writeReviewClick, {
        productName: name,
        productId: id,
      })
    }
    else {
      snowplow.track(constants.snowplowEvents.editReviewClick, false)
    }

    if (isLoggedIn) {
      actions.models.review.setProduct({ id, img, name, brand, category })

      if (userReview) {
        actions.models.modals.open(constants.modals.review.ReviewEdit, {
          userReview,
          onReviewEdited: (productId) => actions.view.productPage.fetchReviews(productId),
        })
      }
      else {
        actions.models.modals.open(constants.modals.review.ReviewComposer, {
          reviewId,
          productTypeGroup,
          onReviewAdded: (productId) => actions.view.productPage.fetchReviews(productId),
        })
      }
    }
    else {
      actions.models.modals.open(constants.modals.review.LoginRequired, {
        toWhatText: messages.modalText,
        urlToProduct: `${urlToProduct}?review`, // adding param 'review' to open review modal after login
      })
    }
  }

  render() {
    const { children, data: { reviewsData: { userReview } }, ...rest } = this.props

    const hasUserReview = Boolean(userReview)
    const buttonProps = object.removeKeys(
      rest,
      'onEditReviewClick',
      'isLoggedIn',
      'urlToProduct',
      'dispatch',
      'productTypeGroup'
    )

    if (children) {
      return (
        React.cloneElement(children, { onClick: this.openModal, ...buttonProps })
      )
    }

    return (
      <Button
        className={s.button}
        title={hasUserReview ? messages.edit : messages.write}
        brand
        xlg
        onClick={this.openModal}
        {...buttonProps}
      />
    )
  }
}


export default compose(
  connect({
    data: 'view.productPage',
    isLoggedIn: 'models.me.isLoggedIn',
    urlToProduct: 'routing.location.pathname',
  }),
)(ReviewButton)
